/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * last_week object
 * @export
 * @interface GetFwLeaderboardsCharactersLastWeekLastWeek1
 */
export interface GetFwLeaderboardsCharactersLastWeekLastWeek1 {
    /**
     * Amount of victory points
     * @type {number}
     * @memberof GetFwLeaderboardsCharactersLastWeekLastWeek1
     */
    amount?: number;
    /**
     * character_id integer
     * @type {number}
     * @memberof GetFwLeaderboardsCharactersLastWeekLastWeek1
     */
    characterId?: number;
}

/**
 * Check if a given object implements the GetFwLeaderboardsCharactersLastWeekLastWeek1 interface.
 */
export function instanceOfGetFwLeaderboardsCharactersLastWeekLastWeek1(value: object): value is GetFwLeaderboardsCharactersLastWeekLastWeek1 {
    return true;
}

export function GetFwLeaderboardsCharactersLastWeekLastWeek1FromJSON(json: any): GetFwLeaderboardsCharactersLastWeekLastWeek1 {
    return GetFwLeaderboardsCharactersLastWeekLastWeek1FromJSONTyped(json, false);
}

export function GetFwLeaderboardsCharactersLastWeekLastWeek1FromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsCharactersLastWeekLastWeek1 {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'characterId': json['character_id'] == null ? undefined : json['character_id'],
    };
}

export function GetFwLeaderboardsCharactersLastWeekLastWeek1ToJSON(json: any): GetFwLeaderboardsCharactersLastWeekLastWeek1 {
    return GetFwLeaderboardsCharactersLastWeekLastWeek1ToJSONTyped(json, false);
}

export function GetFwLeaderboardsCharactersLastWeekLastWeek1ToJSONTyped(value?: GetFwLeaderboardsCharactersLastWeekLastWeek1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'character_id': value['characterId'],
    };
}

